if (!customElements.get('fake-variant-picker')) {
  customElements.define(
    'fake-variant-picker',
    class FakeVariantPicker extends HTMLElement {
      constructor() {
        super();

        this.groupProducts = this.getGroupProducts();
        this.optionKeys = this.getOptionKeys();
        this.isRedirectOnChange = this.hasAttribute('data-redirect-on-change');
        this.addEventListener('change', this.onOptionChange.bind(this));
      }

      getGroupProducts() {
        const productGroupElement = this.querySelector('[data-product-group]');
        if (!productGroupElement) return [];

        try {
          return JSON.parse(productGroupElement.textContent);
        } catch (error) {
          console.error('fake-variant-picker: invalid product group JSON', error);
          return [];
        }
      }

      getOptionKeys() {
        const optionKeysElement = this.querySelector('[data-option-keys]');
        if (!optionKeysElement) return [];

        return optionKeysElement.dataset.optionKeys.split(',').filter(Boolean);
      }

      normalizeValue(value) {
        return String(value ?? '').trim().toLowerCase();
      }

      onOptionChange(event) {
        const changedOptionElement = event.target.closest('[data-option-key]');
        if (!changedOptionElement) return;

        const selectedOptions = this.getSelectedOptions();
        const matchedProduct = this.findProduct(selectedOptions, changedOptionElement.dataset.optionKey);
        if (!matchedProduct) return;

        if (this.isRedirectOnChange) {
          this.redirectToProduct(matchedProduct);
          return;
        }

        this.selectProductOptions(matchedProduct);
        this.updateOptionsAvailability();

        document.dispatchEvent(
          new CustomEvent('fake-variant-picker:change', {
            detail: {
              pickerId: this.dataset.pickerId,
              product: matchedProduct,
            },
          })
        );
      }

      redirectToProduct(product) {
        if (!product.url || product.url === window.location.pathname) return;

        window.location.href = product.url;
      }

      getSelectedOptions() {
        const optionElements = this.querySelectorAll('[data-option-key]');
        const selectedOptions = {};

        optionElements.forEach((optionElement) => {
          const isUncheckedRadio = optionElement.type === 'radio' && !optionElement.checked;
          if (isUncheckedRadio) return;

          selectedOptions[optionElement.dataset.optionKey] = this.normalizeValue(optionElement.value);
        });

        return selectedOptions;
      }

      findProduct(selectedOptions, changedOptionKey) {
        const optionKeys = Object.keys(selectedOptions);

        const exactMatchProduct = this.groupProducts.find((groupProduct) =>
          optionKeys.every((optionKey) => this.normalizeValue(groupProduct[optionKey]) === selectedOptions[optionKey])
        );
        if (exactMatchProduct) return exactMatchProduct;

        const changedOptionProducts = this.groupProducts.filter(
          (groupProduct) => this.normalizeValue(groupProduct[changedOptionKey]) === selectedOptions[changedOptionKey]
        );

        return changedOptionProducts.find((groupProduct) => groupProduct.available) || changedOptionProducts[0];
      }

      selectProductOptions(product) {
        this.querySelectorAll('[data-option-key]').forEach((optionElement) => {
          const productOptionValue = this.normalizeValue(product[optionElement.dataset.optionKey]);

          if (optionElement.type === 'radio') {
            optionElement.checked = optionElement.value === productOptionValue;
          } else {
            optionElement.value = productOptionValue;
          }
        });
      }

      isOptionValueAvailable(optionKey, optionValue, selectedOptions) {
        const previousOptionKeys = this.optionKeys.slice(0, this.optionKeys.indexOf(optionKey));

        return this.groupProducts.some(
          (groupProduct) =>
            groupProduct.available &&
            this.normalizeValue(groupProduct[optionKey]) === optionValue &&
            previousOptionKeys.every(
              (previousOptionKey) => this.normalizeValue(groupProduct[previousOptionKey]) === selectedOptions[previousOptionKey]
            )
        );
      }

      updateOptionsAvailability() {
        const selectedOptions = this.getSelectedOptions();

        this.querySelectorAll('[data-option-key]').forEach((optionElement) => {
          const optionKey = optionElement.dataset.optionKey;

          if (optionElement.type === 'radio') {
            const isDisabled = !this.isOptionValueAvailable(optionKey, optionElement.value, selectedOptions);
            optionElement.disabled = isDisabled;
            optionElement.classList.toggle('fake-option__grid-radio--disabled', isDisabled);
            return;
          }

          Array.from(optionElement.options).forEach((selectOptionElement) => {
            selectOptionElement.disabled = !this.isOptionValueAvailable(optionKey, selectOptionElement.value, selectedOptions);
          });
        });
      }
    }
  );
}